var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"nodata",style:(_vm.outStyle)},[_c('div',{staticClass:"nodata-in"},[_c('img',{staticClass:"nodata_img",attrs:{"src":require('./img/' + _vm.category),"alt":""}}),_c('div',{staticClass:"nodata_word"},[_vm._v(_vm._s(_vm.tipword))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }